import { defineMessages } from 'react-intl';

export default defineMessages({
  startIn: {
    id: 'app.shopDetails.components.Pickup.PickupToggle.delivery.startIn',
    defaultMessage: 'Te llega en',
  },
  delivery: {
    id: 'app.shopDetails.components.Pickup.PickupToggle.delivery.delivery',
    defaultMessage: 'Envío',
  },
  minimum: {
    id: 'app.shopDetails.components.Pickup.PickupToggle.delivery.minimum',
    defaultMessage: 'Mínimo',
  },
  deliveryTime: {
    id: 'app.shopDetails.components.Pickup.PickupToggle.delivery.deliveryTime',
    defaultMessage: '{minMinutes} - {maxMinutes} mins',
  },
  shippingAmountFree: {
    id:
      'app.shopDetails.components.Pickup.PickupToggle.delivery.shippingAmountFree',
    defaultMessage: 'Gratis',
  },
  deliveryAmountNoMin: {
    id:
      'app.shopDetails.components.Pickup.PickupToggle.delivery.deliveryAmountNoMin',
    defaultMessage: 'Sin mínimo',
  },
});
